module.exports = __webpack_public_path__ + "static/media/my-account-deposite.3928dd69.svg";